import { useReadContract, useAccount } from 'wagmi'
import { formatUnits } from 'viem'
import { W2USDT_ADDRESS, UNI2_CHAIN_ID } from '@/constants/addresses'
import { ERC20_ABI } from '@/constants/abis'

export function useW2USDTBalance() {
  const { address, isConnected } = useAccount()

  const { data: balance, isLoading, refetch } = useReadContract({
    address: W2USDT_ADDRESS,
    abi: ERC20_ABI,
    functionName: 'balanceOf',
    args: address ? [address] : undefined,
    chainId: UNI2_CHAIN_ID,
    query: {
      enabled: isConnected && !!address,
      refetchInterval: 15000,
    },
  })

  return {
    balance: balance as bigint | undefined,
    balanceFormatted: balance ? formatUnits(balance as bigint, 18) : '0',
    balanceDisplay: balance ? parseFloat(formatUnits(balance as bigint, 18)).toFixed(4) : '0.0000',
    isLoading,
    refetch,
  }
}
